// extracted by mini-css-extract-plugin
export default {"container":"oS-z","error":"pS-z","disabled":"qS-z","submit":"rS-z","option":"sS-z","success":"tS-z","failure":"uS-z"};